import React from 'react'
import styled from 'styled-components'
import CategoryArticlesPanel from '../../../../components/CategoryArticlesPanel'
import SkeletonListArticle from './components/ListArticle/skeleton'

const Wrapper = styled.div``

const SkeletonListNewsFeed = ({ ...props }) => (
  <Wrapper {...props}>
    <CategoryArticlesPanel />
    <SkeletonListArticle />
  </Wrapper>
)

export default SkeletonListNewsFeed
